import type { CategoryModel } from '../../data-layer/categories/types';
import type { CategoryUI } from '../../ui/categories/types';

export const toCategoryUI = (category: CategoryModel): CategoryUI => category;
